export default "__VITE_ASSET__fd6c94e7__"